import React, { Component } from 'react'
import { Menu } from 'hljd'
import getConfig from './config'
import { observer } from 'mobx-react'
import mainStore from '@components/Main/store'
import { dGet } from '@core/utils'
import { getAuthList } from '@util'
import style from './style.module.less'
import IconLink from './IconLink'
import { hashHistory } from 'react-router'
import { HOME_PATH } from '@constant'
import { GlobalContext } from '../../globalContext'

const { SubMenu, Item } = Menu

export const IconNew = ({ icon_new }) =>
  icon_new ? (
    <i
      className={`iconfont ${icon_new}`}
      style={{
        marginLeft: 6,
        fontSize: 16,
        color: '#ff5c5c',
        verticalAlign: 'middle'
      }}
    />
  ) : null

@observer
export default class extends Component {
  static contextType = GlobalContext

  constructor(props) {
    super(props)
    this.menu = null
    this.openKeys = []
    this.state = {
      openKeys: []
    }
  }

  componentDidMount() {
    this.setState({ openKeys: this.openKeys })
  }

  // 切换当前打开 openKeys
  openChange = openKeys => {
    const { length } = openKeys
    this.setState({
      openKeys: length > 1 ? [openKeys[length - 1]] : openKeys
    })
  }

  // 点击菜单Item
  handleClick = ({
    key,
    keyPath,
    item: {
      props: { hasRender }
    }
  }) => {
    if (keyPath.length === 1) {
      if (hasRender) {
        this.setState({ openKeys: this.state.openKeys }, () => {
          this.setState({ openKeys: this.openKeys })
        })
      } else {
        this.setState({ openKeys: [] })
      }
    }
  }

  // 获取真实路由配置
  getMenu = (config, active, params = {}) => {
    const authList = getAuthList('menu')
    const menus = config.map(item => {
      let {
        key = '',
        title,
        icon,
        icon_new,
        link,
        href,
        parentKey = '',
        sub = [],
        renderMenu,
        hidden = false
      } =
        typeof item === 'function' ? item() : item
      if (typeof sub == 'function') {
        sub = sub(params)
      }

      if (authList && authList.indexOf(key) < 0) {
        return null
      }

      const isHidden = typeof hidden === 'function' ? hidden(params) : hidden

      if (isHidden) {
        return null
      }

      if (active === key) {
        this.openKeys = [parentKey]
      }

      if (sub.length < 1) {
        return (
          <Item key={key} hasRender={!!renderMenu}>
            {renderMenu ? (
              renderMenu(
                Object.assign({}, { icon, title, icon_new }, { link, href }),
                params
              )
            ) : (
              <>
                <IconLink icon={icon} link={link} href={href} title={title} />
                <IconNew icon_new={icon_new} />
              </>
            )}
          </Item>
        )
      } else {
        return (
          <SubMenu
            key={key}
            title={
              renderMenu ? (
                renderMenu({ icon, title, icon_new }, params)
              ) : (
                <span>
                  {icon && <i className={`iconfont ${icon}`} />}
                  {title}
                  <IconNew icon_new={icon_new} />
                </span>
              )
            }
          >
            {this.getMenu(sub, active, params)}
          </SubMenu>
        )
      }
    })
    return menus.filter(Boolean)
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { authList } = this.context // 全局store中的authList更新时更新菜单

    const active = this.props.pathname.split('/')[2] //海草名片小程序跳转修改 原来的父选项变成了跳转选项 然而URL地址还是不能变

    const {
      // eslint-disable-next-line no-unused-vars
      merchantInfo, // todo，暂时不能删除
      is_rev_msg, // is_rev_msg：0-子-接收消息   1-主-不接收
      posterStore
    } = mainStore //is_rev_msg：0-子-接收消息   1-主-不接收
    const banner = dGet(posterStore, 'banner.image_path')
    const config = getConfig()

    this.menu = this.getMenu(config, active, {
      is_rev_msg
    })
    let menuStyle = style
    return (
      <div
        className={menuStyle.content_menu}
        style={{ top: banner ? 124 : 64 }}
      >
        <a
          className={menuStyle.headBox_logo}
          style={{ top: banner ? 60 : 0 }}
          onClick={() => hashHistory.push(HOME_PATH)}
        >
          <img src="//qnm.hunliji.com/o_1coctmepi2861ols1u5i1t221koa9.png" />
        </a>

        {this.menu && (
          <div
            id="sideMenu"
            className={menuStyle.menu}
            style={{
              height: `calc(100% - ${banner ? 124 : 64}px)`
            }}
          >
            <Menu
              onClick={this.handleClick}
              openKeys={this.state.openKeys}
              selectedKeys={[active]}
              onOpenChange={this.openChange}
              mode="inline"
              theme="light"
            >
              {this.menu}
            </Menu>
          </div>
        )}
      </div>
    )
  }
}
